<script>
import IconCard from '@/components/cards/IconCard.vue';
import SocialVisitService from '@/services/SocialVisitsService';

export default {
  components: { IconCard },
  data() {
    return {
      loading: true,
      approvedVisits: 0,
      awaitingConfirmationVisits: 0,
      requestedVisits: 0,
    };
  },
  mounted() {
    this.loading = false;
    this.getSocialVisitStats();
  },
  methods: {
    async getSocialVisitStats() {
      try {
        const { data } = await SocialVisitService.getSocialVisitStats();
        this.requestedVisits = data.requested;
        this.awaitingConfirmationVisits = data.awaitingConfirmation;
        this.approvedVisits = data.approved;
      } catch (e) {
        console.error('Error getting prison stats: ', e);
      }
    },
  },
}
</script>

<template>
  <b-card>
    <loader v-if="loading" />
    <section v-else>
      <b-card-title>
        <b-btn
          class="float-right"
          variant="primary"
          :to="{ name: 'book-social-visit' }"
        >
          Book Visit
        </b-btn>
        <h2>Social Visits</h2>
      </b-card-title>
      <b-row class="px-2 pt-2">
        <b-col cols="4">
          <icon-card
            :statistic="requestedVisits"
            color="primary"
            icon="CalendarIcon"
            route="requested-visits"
            statistic-title="Requested Visits"
            tooltip="These are visits that need your approval"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            :statistic="awaitingConfirmationVisits"
            color="info"
            icon="CalendarIcon"
            route="awaiting-visits"
            statistic-title="Awaiting Confirmation"
            tooltip="These are visits that you have booked and the visitor is waiting to accept"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            :statistic="approvedVisits"
            color="secondary"
            icon="CalendarIcon"
            route="approved-visits"
            statistic-title="Approved Visits"
            tooltip="These are visits both you and the visitor have approved"
          />
        </b-col>
      </b-row>
      <b-row class="px-2 pt-1">
        <b-col cols="4">
          <icon-card
            tooltip="These are visits that are completed"
            route="completed-visits"
            icon="CalendarIcon"
            color="success"
            statistic-title="Completed Visits"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            tooltip="These are visits that you or the visitor have cancelled"
            route="cancelled-visits"
            icon="CalendarIcon"
            color="warning"
            statistic-title="Cancelled Visits"
          />
        </b-col>
        <b-col cols="4">
          <icon-card
            tooltip="These are visits that have been rejected by you"
            route="rejected-visits"
            icon="CalendarIcon"
            color="danger"
            statistic-title="Rejected Visits"
          />
        </b-col>
      </b-row>
    </section>
  </b-card>
</template>
